export function setDataLoginRequest(investor, multiBroker, billingStatus) {
	return {
		type: "@sessionStorage/SET_DATA_LOGIN_REQUEST",
		payload: {
			investor,
			multiBroker,
			billingStatus,
		},
	};
}

export function verifyHealthCheckRequest() {
	return {
		type: "@sessionStorage/VERIFY_HEALTH_CHECK_REQUEST",
		payload: {},
	};
}

export function initialStateCheck(state) {
	return {
		type: "@sessionStorage/INITIAL_STATE_CHECK",
		payload: {
			state,
		},
	};
}
